<template>
  <div>
    <lateralNavigation2></lateralNavigation2>
    <rightNav></rightNav>
    <div class="placeOrder warp" style="padding-top: 20px">
      <div class="poAddressBox">
        <div class="poTitle">请选择收货地址</div>
        <div class="noAddress" v-if="addressData.length == 0" @click="newAddressFn">
          <div class="noAddressBox">
            <span class="iconfont">&#xe6d4;</span>
            <span>新增收货地址</span>
          </div>
        </div>
        <div class="poAddressList" v-if="addressData.length !== 0">
          <div class="poAddListTit">
            <span>收件人信息</span>
            <span @click="newAddressFn">新增地址</span>
          </div>
          <div class="poAddListBox">
            <div class="showMoreBox" :class="{showMoreAdd: showMoreAddress}">
              <div class="addressItem" :class="{addressActive: curAdd === index}" @click="selectAddress(item, index)" v-for="(item, index) of addressData" :key="index">
                <el-radio v-model="radio" :label="item.id" @change="changeAddr">选择地址</el-radio>
                <span class="userName">{{item.realName}}</span>
                <span class="addressInfo">{{item.province}}{{item.city}} {{item.district}}{{item.detail}}</span>
                <span class="phone">{{item.phone}}</span><i v-if="item.isDefault==1" class="iconfont" style="font-size: 1px; color: #D22929;margin-left: 5px;">默认&#xe612;</i>

                <el-button class="buttonAddress" type="primary" @click="delAddressData(item)" style="position: absolute;right: 250px;margin-top: 10px"> 删  除</el-button>
                <el-button class="buttonAddress" type="primary" @click="updateAddressFn(item)" style="position: absolute;right: 150px;margin-top: 10px">修  改</el-button>
              </div>
            </div>
            <div class="openMore iconfont" @click="openMoreAdd" v-html="showMoreAddress ? '收起地址&#xe660;' : '展开更多&#xe695;'"></div>
          </div>
        </div>
        <div class="poTitle">请确认订单信息</div>
        <div class="orderList">
          <div class="orderInfoTit">
            <span>店铺商品</span>
            <span>商品属性</span>
            <span>单价</span>
            <span>数量</span>
<!--            <span>优惠方式</span>-->
            <span>小计</span>
          </div>
        </div>
        <shop-order ref="shopOrder" :shopsData="shopsData"></shop-order>
      </div>
      <div class="remarksBox">
        <div class="remarksInfo">
          <el-input
            type="textarea"
            :rows="2"
            resize="none"
            placeholder="如有其他要求，请备注。"
            v-model="remarksInfo">
          </el-input>
        </div>
      </div>
      <div class="couponBox">
                <!-- <div class="couponTitle" v-if="settlementData.coupons.length !== 0"><span>使用优惠券<i class="iconfont" v-html="'&#xe695;'"></i></span></div> -->
        <div class="couponTitle" ><span>使用优惠券<i class="iconfont" v-html="'&#xe695;'"></i></span></div>
		    <div v-if="coupons.length == 0" style="margin-top: 10px;color: #D22929;">暂无可用优惠券</div>
        <div class="discountList clearfix">

          <div @click="preferentialUse(item, index)" class="couponItem" :class="{active: currentCoupon === index}" v-for="(item, index) of coupons" :key="index">
            <div class="couponItemTop">
              <img src="../../assets/images/indexLogo.png" alt="">
              <!-- <span><i>￥</i>{{item.reduceMoney}}</span> -->
              <span><i>￥</i>{{item.couponPrice}}</span>
              <span>使用条件：满{{item.useMinPrice}}减{{item.couponPrice}}</span>
              <span>有效期：{{item.startTime}}-{{item.endTime}}</span>
              <div class="couponType">{{item.type == "0" ? "通用卷":"商品卷"}}</div>
            </div>
            <div class="couponItemBot">
              立即使用
              <span class="iconfont currentSelect" v-if="currentCoupon === index">&#xe612;</span>
            </div>
          </div>
        </div>
        <div class="couponList">
          <div class="payTit">选择支付方式</div>
          <div class="payList">
<!--            <span :class="{payActive: payType === 'alipay'}" @click="selectPay(type = 'alipay')">-->
<!--              <i class="iconfont">&#xe627;</i>-->
<!--              <b class="iconfont">&#xe612;</b>-->
<!--              支付宝支付-->
<!--            </span>-->
<!--            <span :class="{payActive: payType === 'weChat'}" @click="selectPay(type = 'weChat')">-->
<!--              <i class="iconfont">&#xe686;</i>-->
<!--              <b class="iconfont">&#xe612;</b>-->
<!--              微信支付-->
<!--            </span>-->

<!--               <span :class="{payActive: payType === 'alipay'}" @click="selectPay(type = 'alipay')">-->
<!--            <img src="../../../static/image/alipay.png" alt="">-->
<!--              <b class="iconfont">&#xe612;</b>-->
<!--              支付宝-->
<!--            </span>-->
             <span :class="{payActive: payType === 'payByArrive'}" @click="selectPay(type = 'payByArrive')">
              <i class="iconfont"></i>
              <b class="iconfont">&#xe612;</b>
              货到付款
            </span>

            <span :class="{payActive: payType === 'card'}" @click="selectPay(type = 'card')">
              <b class="iconfont">&#xe612;</b>
              线下转账
            </span>

            <span :class="{payActive: payType === 'xysk'}" @click="selectPay(type = 'xysk')">
              <b class="iconfont">&#xe612;</b>
              协议收款
            </span>

          </div>
        </div>
      </div>
      <div class="invoice" style="margin: 30px 0px;">
        <div class="poTitle">发票信息 <el-checkbox change="invoiceFlagChange" v-model="invoiceFlag">开具发票</el-checkbox></div>
        <div v-if="invoiceFlag">

        <div style="color: #606266;padding-left: 49px;font-size: 14px;">
          发票模板:
          <el-select v-model="invoiceValue" placeholder="请选择发票模板" clearable @change="changeInv" @clear="clearInv" style="margin-left: 20px;">
              <el-option
                v-for="item in invoiceList"
                :key="item.id"
                :label="item.invoiceName"
                :value="item.id">
              </el-option>
            </el-select>
        </div>

          <el-form :rules="rules" ref="form" :model="invoiceBean" label-width="130px">
            <el-form-item label="发票形式： " prop="billingType">
              <el-radio-group v-model="invoiceBean.billingType">
                <el-radio :label="1" >电子发票</el-radio>
                <el-radio :label="2">纸质发票</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="发票类型：" prop="invoiceType">
              <el-radio-group v-model="invoiceBean.invoiceType">
                <el-radio :label="0">增值税普通发票</el-radio>
                <el-radio v-if="invoiceBean.billingType == '2' && invoiceBean.invoiceUnit == '0'" :label="1">增值税专用发票</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="普通类型：" prop="invoiceUnit">
              <el-radio-group v-model="invoiceBean.invoiceUnit">
                <el-radio :label="0">公司</el-radio>
                <el-radio :label="1">个人</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="发票抬头：" prop="invoiceName">
              <el-input clearable v-model="invoiceBean.invoiceName"></el-input>
              <!-- <el-checkbox v-model="invoiceBean.desc">设为默认抬头</el-checkbox> -->
            </el-form-item>
            <div v-if="invoiceBean.invoiceUnit == '0'">
              <el-form-item label="纳税识别号：" prop="taxId">
                <el-input  v-model="invoiceBean.taxId"></el-input>
                <!-- <span>选择更多抬头 <i class="el-icon-d-arrow-right"></i></span> -->
              </el-form-item>
              <el-form-item label="开户银行：" :required="invoiceBean.invoiceType == '1' ? true:false"  :show-message="false" >
                <el-input placeholder="请填写开户银行"  v-model="invoiceBean.bankAccount"></el-input>
              </el-form-item>
              <el-form-item label="银行账号：" :required="invoiceBean.invoiceType == '1' ? true:false" :show-message="false" >
                <el-input placeholder="请填写银行账号" v-model="invoiceBean.bankAccounts"></el-input>
              </el-form-item>
              <el-form-item label="企业地址：" :required="invoiceBean.invoiceType == '1' ? true:false" :show-message="false" >
                <el-input placeholder="请填写企业地址" v-model="invoiceBean.businessAddress"></el-input>
              </el-form-item>
              <el-form-item label="企业电话：" :required="invoiceBean.invoiceType == '1' ? true:false" :show-message="false">
                <el-input placeholder="请填写企业电话" v-model="invoiceBean.phone"></el-input>
              </el-form-item>
            </div>
            <!-- <span v-else style="left: 140px;position: relative;font-size: 14px;">选择更多抬头 <i class="el-icon-d-arrow-right"></i></span> -->
            <!-- <el-form-item>
              <el-button type="primary">立即创建</el-button>
              <el-button>取消</el-button>
            </el-form-item> -->
          </el-form>
        </div>
        <div v-if="invoiceBean.billingType == '2' && invoiceFlag">
          <div class="poTitle">发票邮寄地址</div>
          <el-form ref="formAddr" :rules="rulesAddr" :model="invoiceBean" label-width="130px">
            <el-form-item label="申请人：" >
              <el-input placeholder="请填写申请人信息" v-model="invoiceBean.memberName"></el-input>
            </el-form-item>
            <el-form-item label="联系电话："  >
              <el-input placeholder="请填写联系电话" v-model="invoiceBean.contactNumber"></el-input>
            </el-form-item>
            <el-form-item label="公司地址：" >
              <el-input placeholder="请填写公司地址" v-model="invoiceBean.companyAddress"></el-input>
            </el-form-item>
            <el-form-item  label="详细地址：">
              <el-input placeholder="请填写详细地址" v-model="invoiceBean.emailAddress"></el-input>
            </el-form-item>

          </el-form>
        </div>
      </div>
      <div class="placeOrderBtn">
        <span>商品优惠：-￥{{couponPrice}}</span>
        <span>运费：<b>{{priceGroup.storePostage> 0?priceGroup.storePostage:"免运费"}}</b></span>
        <span>合计：<b>{{priceGroup.totalPrice}}</b></span>
        <span>需付款：<b>￥{{priceGroup.storePostage>0?parseInt(totalPrice)+parseInt(priceGroup.storePostage):totalPrice}}</b></span>
        <el-button @click="clickPayOrder" type="primary" v-throttle>提交订单</el-button>
      </div>
      <el-dialog
        title="请在1小时内完成付款，否则订单会被系统取消"
        :visible.sync="paymentDialog"
        width="30%">
        <div class="payment">
          <div class="paymentBox">
            <div class="successBox">
              <span>支付成功请点击</span>
              <el-button type="primary" plain>已完成付款</el-button>
            </div>
            <div class="errorBox">
              <span>遇到问题请点击</span>
              <el-button type="primary" v-throttle>重新付款</el-button>
            </div>
          </div>
          <div class="paymentInfo">
            <p>注：重新付款前，请关闭之前的付款页面</p>
            <p>如有疑问或需要帮助，请进入<b>帮助中心</b>或联系<b>在线客服</b></p>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        class="weChat"
        :title="`请使用${payTitle}扫一扫支付实际付款： ￥${payInfo.money}`"
        :visible.sync="weChatDialog"
        :before-close="handleClose"
        width="30%">
        <div class="weChatBox">
          <div class="qCode">
                <div id="qrcode" class="qrcode" ref="qrcode"></div>
            <!-- <img style="float: left;" src="../../assets/images/weiXintit.png" alt=""> -->
            <img style="float: left;" :src="payTypeImg" alt="">
          </div>
          <div class="weChatInfo">
            <img :src="payImg" alt="">
            <!-- <img src="../../assets/images/imgPay.png" alt=""> -->
          </div>
        </div>
      </el-dialog>
      <el-dialog
       :title="title"
       :visible.sync="newAddressDialog"
       :close-on-click-modal="false"
       width="30%">
        <add-address @hideAddDialog="hideAddDialog" @cancelAdd="closeAdd" :updateAddressDate='updateAddressDate' ref="addAddr"></add-address>
      </el-dialog>
      <el-dialog
        title="错误！"
        :visible.sync="errorDialog"
        width="30%">
        <div class="errorDialog">
          <div class="errorTit">
            <span class="iconfont">&#xe620;</span>
            <p>您的订单支付失败</p>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false" v-throttle>查看订单</el-button>
            <el-button type="primary" @click="dialogVisible = false" v-throttle>重新支付</el-button>
          </span>
        </div>
      </el-dialog>
    </div>
    </div>

</template>

<script>
import addAddress from '../../components/orderInfo/addAddress'
import shopOrder from '../../components/orderInfo/shopOrder'
import couponList from '../../components/orderInfo/coupon'
import QRCode from 'qrcodejs2'
import api from '@/api'
import { listSearchMixin } from '@/config/mixin'
import { mapGetters, mapMutations } from 'vuex'

import { regionData, CodeToText } from 'element-china-area-data'
import lateralNavigation2 from "../../components/base/lateralNavigation2";
import rightNav from "../../components/canvasShow/rightNav";
export default {
  name: 'placeOrder',
  mixins: [listSearchMixin],
  components: {
    lateralNavigation2,
    rightNav,
    addAddress,
    shopOrder,
    couponList
  },
  data () {
    var checkEmailAddress = (rule, value, callback) => {
      console.log(value)
      if (value) {
        if (value.length >= 50) {
            this.$message.warning('详细地址不能大于50个字符')
        }
      }
    }
    var checkContactNumber = (rule, value, callback) => {
      if (value) {
        var pattern = /^1[34578]\d{9}$/
          if (pattern.test(value)) {
            return true
          }
          this.$message.warning('联系电话格式不正确')
      }
    }
    return {
      title: '新建收货地址',
      addressData: [],
      addressId: 0,
      payImg: '../../assets/images/imgPay.png',
	    payTypeImg: '',
	    payTitle: '',
      showMoreAddress: false,
      newAddressDialog: false,
      paymentDialog: false,
      weChatDialog: false,
      payType: '',
      money: 0,
      allMoney: 0.0,
      errorDialog: false,
      curAdd: null,
      settlementData: {
        coupons: []
      },
      // settlementType: JSON.parse(this.$route.query.type),
      // shopData: JSON.parse(this.$route.query.shops),
      shopsData: [],
      showDiscount: false,
      currentCoupon: null,
      prefAmount: 0,
      orderTotal: 0,
      orderKey: '',
      couponCurrent: {},
      submitData: {
        receiveId: '',
        couponId: '',
        price: '',
        remark: '',
        shops: []
      },
      currentAddressId: '',
      remarksInfo: '',
      payInfo: {},
      chatTimer: '',
      priceGroup: {},
	    updateAddressDate: {},
      // 可用优惠券
      coupons: [],
      // 优惠金额
      couponPrice: 0,
      // 记录优惠券取消选中点击flag
      couponFlag: true,
      // 新增订单发票
      invoiceFlag: false,
      invoiceBean: {
        billingType: 1,
        invoiceType: 0,
        invoiceUnit: 1,
        invoiceName: '',
        taxId: '',
        bankAccount: '',
        bankAccounts: '',
        companyAddress: '',
        phone: '',
        memberName: '',
        contactNumber: '',
        // companyAddress:"深圳市"
        emailAddress: ''
      },
      invoiceBean2: {
        phone: '',
        memberName: '',
        contactNumber: '',
        emailAddress: ''
      },
      radio: 3,
      rules: {
          billingType: [
            { required: true, message: '', trigger: 'change' }
          ],
          invoiceType: [
            { required: true, message: '', trigger: 'change' }
          ],
          invoiceUnit: [
            { required: true, message: '', trigger: 'change' }
          ],
          invoiceName: [
            { required: true, message: '请输入发票抬头', trigger: 'blur' }
          ],
          taxId: [
            { required: true, message: '请输入纳税识别号', trigger: 'blur' }
          ],
          emailAddress: [
            {validator: checkEmailAddress, trigger: 'change'}
          ]

        },
        rulesAddr: {
          memberName: [
            { required: true, message: '请填写申请人信息', trigger: 'blur' }
          ],
          contactNumber:[
            // {validator: checkContactNumber, trigger: 'blur'}
            { required: true, message: '请填写联系电话', trigger: 'blur' }
          ],
          companyAddress: [
            { required: true, message: '请填写公司地址', trigger: 'blur' }
          ],
          emailAddress: [
            { required: true, message: '请填写详细地址', trigger: 'blur' }
          ]
	      },
        // 验证form是否可过验证
        verifyFormFlag: true,
        invoiceList: [],
        invoiceValue: '',
        regionData: regionData
        }
  },
  mounted () {
    this.getAddressData()
    this.computedPrice()
    this.curAdd = 0
    // this.getSetProList()
	  this.getAddressList()
    // 查询个人默认发票抬头
    this.getUserDefaultInvoice();
		this.invoiceRecords(0)
		this.invoiceRecords(1)
  },
  computed: {
    ...mapGetters([
      'newAddress' // 新增修改收货地址
    ]),
	// 计算总计
	totalPrice () {
		return this.shopsData.reduce((pre, cur, index) => {
        if (this.couponFlag) {
          this.couponPrice = 0.0
          return pre += cur.truePrice * cur.cartNum
        } else {
          // this.couponPrice = currentCoupon
          if(index == 0){
            return pre += cur.truePrice * cur.cartNum - this.couponPrice
          }else{
            return pre += cur.truePrice * cur.cartNum
          }
        }
		},0)
	}
  },
  methods: {
  clearInv () {
    console.log('clear')
    this.invoiceBean.taxId = ''
    this.invoiceBean.bankAccount = ''
    this.invoiceBean.bankAccounts = ''
    this.invoiceBean.businessAddress = ''
    this.invoiceBean.phone = ''
    this.invoiceBean.invoiceName = ''
    this.invoiceBean.invoiceInfoId = ''
  },
  // 选择模板
  changeInv () {
    console.log(this.invoiceValue)
    this.invoiceBean.taxId = ''
    this.invoiceBean.bankAccount = ''
    this.invoiceBean.bankAccounts = ''
    this.invoiceBean.businessAddress = ''
    this.invoiceBean.phone = ''
    let index = this.invoiceList.findIndex(item => item.id == this.invoiceValue)
    if (!this.invoiceList[index]) return
    if (this.invoiceList[index].taxId) {
      // 公司
      this.invoiceBean.invoiceUnit = 0
      this.invoiceBean.taxId = this.invoiceList[index].taxId
      this.invoiceBean.bankAccount = this.invoiceList[index].bankAccount
      this.invoiceBean.bankAccounts = this.invoiceList[index].bankAccounts
      this.invoiceBean.businessAddress = this.invoiceList[index].address
      this.invoiceBean.phone = this.invoiceList[index].phone
      this.invoiceBean.companyAddress = this.invoiceList[index].companyAddress
      this.invoiceBean.contactNumber = this.invoiceList[index].contactNumber
      this.invoiceBean.memberName = this.invoiceList[index].memberName
      this.invoiceBean.emailAddress = this.invoiceList[index].emailAddress
      this.invoiceBean.invoiceInfoId = this.invoiceList[index].id
    } else {
      this.invoiceBean.invoiceUnit = 1
    }
    // 个人
    this.invoiceBean.invoiceName = this.invoiceList[index].invoiceName
      console.log(this.invoiceList[index])
  },
    // 获取发票模板
  invoiceRecords(invoiceUnit){
    let params = {
      url: api.invoiceInfoRecords,
      method: 'POST',
      data: {
        invoiceUnit
      }
    }
    this.sendReq(params, (res) => {
      this.invoiceList = [...this.invoiceList,...res.data.data]
    })
  },
  changeAddr () {
  console.log('radio', this.radio)
  },
  // 是否开具发票改变事件
  invoiceFlagChange () {

  },
  // 查询个人默认发票抬头
  getUserDefaultInvoice (unit) {
    var self = this
    let params = {
      url: api.invoiceDefaultInfo,
      method: 'post',
      data: {
        invoiceUnit: unit ? unit : this.invoiceBean.invoiceUnit
      }
    }
     self.sendReq(params, (res) => {
        var bean = res.data
        delete bean.id
        bean.businessAddress = bean.address
        this.invoiceBean = bean
        this.$set(this.invoiceBean, 'billingType', 1)
     })
  },
    qrcodeScan (url) { // 生成二维码
      let qrcode = new QRCode('qrcode', {
          width: 200, // 二维码宽度
          height: 200, // 二维码高度
          text: url
      })
    },
    ...mapMutations({
      seNewAddress: 'SET_NEWADDRESS', // 新增修改收货地址
      setAreacode: 'SET_AREACODE', // 新增修改收货地址
      setCartNumber: 'SET_CARTNUMBER',
      setShoppingCart: 'SET_SHOPPINGCART'
    }),
    getAddressData () {
      let self = this
      let params = {
        url: api.addressList,
        method: 'get',
        data: {
        }
      }
      self.sendReq(params, (res) => {
		  console.log(res)
        if (res.success) {
			let defaultAddr = {}

			let index = res.data.findIndex(item => item.isDefault == 1)
      res.data.forEach(item => {
				if(item.isDefault == 1) {
						this.currentAddressId = item.id
						this.addressId = item.id
						defaultAddr = item
						this.radio = item.id
					}
				})
				if(index>=0){
					res.data.splice(index,1)
					res.data.unshift(defaultAddr)
				}
				self.addressData= res.data;
      } else {
          self.$message.error(res.msg)
        }
      })
    },
    // 获取信息
    getAddressList () {
	console.log(this.$route.query.id)
      let self = this
      let params = {
        url: api.confirm,
        method: 'POST',
        data: {
          cartId:this.$route.query.id
        }
      }
      self.sendReq(params, (res) => {
        if (res.success) {
			console.log(res.data)
          self.shopsData=res.data.cartInfo;
          this.orderKey=res.data.orderKey;
          // self.usableCoupon=res.data.usableCoupon;
          self.coupons=res.data.usableCoupon;
          self.priceGroup=res.data.priceGroup
					console.log('-----',res)
        }
      })
    },
    computedPrice () {
      console.log("----计算订单金额-----")
      console.log(this.$route.query.id)
      let self = this
      let params = {
        url: api.postOrderComputed+"/"+this.$route.query.id,
        method: 'POST',
        data: {
          cartId:this.$route.query.id
        }
      }
      self.sendReq(params, (res) => {
        if (res.success) {
          let arr=[];
          arr.push(res.data.addressInfo);
          self.addressData = arr;
          self.shopsData=res.data.cartInfo;
          self.shopsData=res.data.usableCoupon
		  console.log('0000')
        }
      })
    },
    // 新增地址
    hideAddDialog (isDefault) {
	isDefault = isDefault || 0
	console.log(123123)
      this.newAddressDialog = false
      let self = this
      let params = {
        url: api.newAddress,
        method: 'POST',
        data: {
			id: this.updateAddressDate.id ? this.updateAddressDate.id : '',
          real_name: self.newAddress.realName,
          phone: self.newAddress.phone,
          addressInfo: self.newAddress.receiveAdress,
          detail: self.newAddress.detail,
          is_default: isDefault == 1 ? true : false,//self.newAddress.isDefault
          post_code: "",
        }
      }
      self.sendReq(params, (res) => {
		  console.log(res)
        if (res.success) {
          self.$message({
            message:  this.updateAddressDate.id ? '地址修改成功':'地址添加成功',
            type: 'success'
          })
          self.page = 1
          // self.addressData = []
          self.setAreacode([])
		  this.getAddressData()
			// this.addressData.splice(this.addressData.findIndex(item => item.id == this.updateAddressDate.id),1)
        } else {
          self.$message.error(res.msg)
        }
      })
    },
    // 取消新增地址
    closeAdd () {
      this.newAddressDialog = false
    },
    selectAddress (item, index) {
		console.log(item.id)
      this.curAdd = index
      this.currentAddressId = item.receiveId
      this.addressId = item.id;
    },
    // 新增地址
    newAddressFn () {
		this.title = '新增收货地址'
		this.updateAddressDate = {}
      let obj = {
        receiveName: '',
        receivePhone: '',
        receiveAdress: '',
        address: '',
        label: '',
        isDefault: false
      }
      this.setAreacode([])
      this.seNewAddress(obj)
      this.newAddressDialog = true

      this.getAddressData();
    },
  delAddressData(item){

 this.$confirm('确认删除改地址？')
        .then(_ => {
         const params = {
        url: api.delAddress,
        method: "POST",
        data: {
          id: item.id,
        },
      };
      this.sendReq(params, (res) => {
          this. getAddressData();
      });
        })
        .catch(_ => {})
  },

  updateAddressFn(item){
	  this.updateAddressDate = item
	  let areaCode = []
	  console.log(item)
	  let provIndex = this.regionData.findIndex(i => i.label == item.province)
	  let cityIndex = this.regionData[provIndex].children.findIndex(i => i.label == item.city)
	  if(this.regionData[provIndex].children.length == 1) cityIndex = 0
	  let distIndex = this.regionData[provIndex].children[cityIndex].children.findIndex(i => i.label == item.district)
	  areaCode.push(this.regionData[provIndex].value)
	  areaCode.push(this.regionData[provIndex].children[cityIndex].value)
	  areaCode.push(this.regionData[provIndex].children[cityIndex].children[distIndex].value)
	  console.log(this.$refs)
	  if(this.$refs.addAddr) this.$refs.addAddr.addressChange(areaCode)
      this.title = "修改收货地址";
     this.setAreacode(areaCode)
      this.seNewAddress(item)
      this.newAddressDialog = true
      this.getAddressData();
  },

    // 展开更多地址
    openMoreAdd () {
      this.showMoreAddress = !this.showMoreAddress;
    },
    // 查询结算产品列表
    getSetProList () {
      let self = this
      let params = {
       // url: api.getSettlement,
       url:api.getTrolleyList,
        method: 'get',
      }
	  if(this.$route.query.only == 'only') return
      self.sendReq(params, (res) => {
        if (res.success) {
          self.settlementData = res.data.valid
           self.shopsData = res.data.valid
          for (let key in self.shopsData) {
            self.orderTotal = self.orderTotal + self.shopsData[key].total
          }
          console.log("------",res);
    //       for(let money in self.settlementData){
    //       //  self.settlementData[money]*self.settlementData[truePrice]
    //         this.allMoney +=(self.settlementData[money].cartNum)*(self.settlementData[money].truePrice);
    //       }
		  // //
		  // this.allMoney = this.shopsData.reduce((pre,cur)=>{
			 //  return pre += cur.truePrice * cur.cartNum
		  // },0)
    //       console.log("---",this.allMoney);
        }
      })
    },
    preferentialUse (item, index) {
      this.couponFlag = !this.couponFlag;
      this.couponPrice = item.couponPrice;
      //如果切换了优惠券点击
      if(this.couponCurrent){
        if(this.couponCurrent.id != item.id){
          this.couponFlag = false;
          this.couponPrice = item.couponPrice;
        }
      }
      if (this.currentCoupon === index) {
        this.prefAmount = 0
        this.couponCurrent = {}
        this.currentCoupon = null
      } else {
        this.couponCurrent = item
        this.prefAmount = item.reduceMoney
        this.currentCoupon = index
      }

    },
    // 选择支付方式
    selectPay (type) {
      this.payType = type
    },
    // 提交支付
    clickPayOrder () {
		if(!this.radio) return this.$message('请选择地址！')
       if (this.payType === '') {
        this.$message('请选择支付方式')
      } else if (this.currentAddressId === '') {
        this.$message('请选择您的收货地址')
      } else {
        let shops = []
        // this.shopsData.forEach((j, i) => {
        //   let skus = []
        //   j.skus.forEach((k, n) => {
        //     if (k.selected) {
        //       skus.push({
        //         skuId: k.skuId,
        //         number: k.number,
        //         selected: k.selected
        //       })
        //     }
        //   })
        //   if (skus.length) {
        //     shops.push({
        //       shopId: j.shopId,
        //       distribution: {
        //         distributionPrice: j.distribution.distributionPrice,
        //         logisticsId: j.distribution.logisticsId
        //       },
        //       skus
        //     })
        //   }
        // })
        /* 是否需要验证发票信息填写完整 */
        this.verifyFormFlag = true;
        if(this.invoiceFlag){
          this.$refs.form.validate((valid) => {
            if (!valid) {
              this.$message.warning("发票信息需填写完整");
              this.verifyFormFlag = false;
            }
          });
          if(this.invoiceBean.billingType == 2){
            /*if(!this.invoiceBean.memberName || !this.invoiceBean.contactNumber || !this.invoiceBean.companyAddress || !this.invoiceBean.emailAddress){
              this.$message.warning("发票邮寄地址需填写完整");
              this.verifyFormFlag = false;
            }*/
          }
        }
		// this.$refs.formAddr.validate((valid1) => {
		// 			  console.log('v2',valid1)
		//   if (!valid1) {
		//     this.$message.warning("发票邮寄地址需填写完整");
		//     this.verifyFormFlag = false;
		//   }
		// });
        if(!this.verifyFormFlag){
          return false;
        }
        this.submitData.couponId = this.couponCurrent.id||0
        this.submitData.receiveId = this.currentAddressId
        this.submitData.price = this.totalPrice;
        this.submitData.mark = this.remarksInfo;
        this.submitData.shops = shops
        this.submitData.addressId=this.addressId;
         this.submitData.from="weixinh5";
         this.submitData.payType=this.payType
         this.submitData.phone="17512080664";
         this.submitData.pinkId=0;
         //"配送方式 1=快递 ，2=门店自提")
         this.submitData.shippingType=1;
         //"支付渠道(0微信公众号1微信小程序) "
          this.submitData.isChannel=1;
          //订单来源 1->PC 2->H5
          this.submitData.source=1;
          // console.log(this.submitData);
		  console.log(this.submitData)
        this.orderSubmit(this.submitData, 'submitData')
      }
    },
    orderSubmit (subData) {
      console.log(subData);
      let self = this
      let params = {
        url: api.orderSubmit+"/"+this.orderKey,
        method: 'POST',
        data: subData
      }
      self.sendReq(params, (res) => {
        console.log("");
        console.log(res.data);
        if (res.success) {
          // self.pay(res.data)
          self.payInfo = res.data
          self.payInfo.url = res.data.result;
           self.payInfo.money=res.data.money
           self.payInfo.payType=this.payType

           if(this.payType=="alipay"){
              this.payTypeImg="http://slwmall.oss-cn-beijing.aliyuncs.com/admin/2021-03-15/db8b8dfbdd8d4a1db192c7b1f6bfe158aliIntit.png";
              this.payImg="http://slwmall.oss-cn-beijing.aliyuncs.com/admin/2021-03-15/6af28324354042e2b82113bedee6392fimgPayAli.png";
			  this.payTitle="支付宝"
           }else if(this.payType=="weChat"){
             this.payTypeImg="http://slwmall.oss-cn-beijing.aliyuncs.com/admin/2021-03-15/30c7e89a9d82494abbfa83cc55960986weiXintit.png";
             this.payImg="http://slwmall.oss-cn-beijing.aliyuncs.com/admin/2021-03-15/80a60f2ea10a4c52ba05df93748cdc4bimgPay.png";
			  this.payTitle="微信"
           }

           //创建订单发票
           if(this.invoiceFlag){
             this.invoiceBean.orderId = res.data.orderId;
             this.invoiceBean.totalAmount = this.totalPrice;
             this.createOrderInvoice();
           }
          // console.log(res.data, '提交返回')
         // this.qrcodeScan("www.baidu.com");
          if(this.payType=="payByArrive" || this.payType=="card" || this.payType=="xysk"){
            clearInterval(this.chatTimer)
            this.$router.push({path: '/myOrder'})
          }else{

          }
          console.log(this.payType);
          if(this.payType=="alipay"||this.payType=="weChat"){
                this.$nextTick (function () {
                              this.qrcodeScan(res.data.result);
                            })
                          self.weChatDialog = true
                          self.chatTimer = setInterval(() => {
                            self.checkPay(res.data)
                          }, 3000)
          }
        } else {
          if(res.msg){
            self.$message({
              message: res.msg || '提交订单失败!',
              type: 'warning'
            })
          }else{
            self.$message({
              message: res.message || '提交订单失败!',
              type: 'warning'
            })
          }
        }
      })
    },
    checkPay (paramsData) {
      setTimeout(() => {
        let self = this
        let params = {
          url: api.getOrderDetail+"/"+paramsData.orderId,
          method: 'GET',
          data: {
            orderId: paramsData.orderId,
            type: '1'
          }
        }
        self.sendReq(params, (res) => {

          if (res.data._status._type==1) {
              self.$message({
                message: '支付成功！',
                type: 'success'
              })
              clearInterval(self.chatTimer)
              self.getTrolleyList()
              self.$router.push({path: '/myOrder'})
          } else {
            console.log("没完成");
           // clearInterval(self.chatTimer)
            // self.$message({
            //   message: res.message,
            //   type: 'error'
            // })
          }
        })
      }, 0)
    },
    // 购物车列表
    async getTrolleyList () {
      const vm = this
      const params = {
        url: api.getTrolleyList,
        method: 'GET'
      }
      vm.sendReq(params, res => {
        const d = res.data
        let cartNumber = 0

       // let money =0.0;
        if (d.length) {
          d.forEach(j => {
            cartNumber = cartNumber + j.skus.length
           // money+=k.cartNumber*truePrice
          })
        }
        this.setShoppingCart(d)
        this.setCartNumber(cartNumber)
      })
    },
    handleClose () {
      this.$confirm('确认取消支付？')
        .then(_ => {
          clearInterval(this.chatTimer)
          this.$router.push({path: '/myOrder'})
        })
        .catch(_ => {})
    },
    //创建订单发票
    async createOrderInvoice(){
      let params = {
          url: api.invoiceAdd,
          method: 'POST',
          data: this.invoiceBean
      }
      this.sendReq(params, (res) => {
        console.log(res);
      })
    }
  },
  watch: {
    prefAmount (val, oldVal) {
      if (val === 0) {
        this.orderTotal = this.orderTotal + oldVal
      } else {
        this.orderTotal = this.orderTotal - val
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.qrcode{
    display: flex;
    justify-content: center
}
	.userName {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
.placeOrder {
  margin: 20px auto;
  .poTitle {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 20px;
  }
  .poAddressList {
    width: 100%;
    border: 1px solid #F5F5F5;
    padding: 20px;
    margin-bottom: 30px;
    box-sizing: border-box;
    .poAddListTit {
      display: flex;
      justify-content: space-between;
      span:nth-child(1) {
        color: #333333;
        font-size: 16px;
      }
      span:nth-child(2) {
        color: #2D51B3;
        font-size: 14px;
        cursor: pointer;
      }
    }
    .poAddListBox {
      width: 100%;
      margin:20px 50px 0 50px;
      .showMoreBox {
        height: 45px;
        overflow: hidden;
      }
      .showMoreAdd {
        height: auto;
      }
      .addressItem {
		    position: relative;
        display: flex;
        align-items: center;
        margin-bottom: 17px;
	    	height: 33px;
        span {
          color: #666666;
          font-size: 14px;
        }
        span:nth-child(1) {
          width: 147px;
          height: 31px;
          line-height: 31px;
          text-align: center;
          border: 1px solid #CCCCCC;
          border-radius: 2px;
          margin-right: 15px;
          cursor: pointer;
          position: relative;
          i {
            font-size: 16px;
            height: 16px;
            line-height: 16px;
            position: absolute;
            right: -1px;
            bottom: 0;
            color: $mainColor;
          }
        }
        span:nth-child(2) {
          margin-right: 20px;
        }
        .buttonAddress{
          height: 30px;
          width: 70px;
          line-height:1px ;
        }
      }
      .openMore {
        font-size: 12px;
        color: #666666;
        cursor: pointer;
      }
      .currentAddress {
        span:nth-child(1) {
          border-color: $mainColor;
        }
      }
      // .addressActive {
      //   span:nth-of-type(1) {
      //     border-color: $mainColor;
      //   }
      // }
      .showMoreAdd {
        height: auto;
      }
    }
  }
  >>> .el-dialog {
    width: 33% !important;
    .el-dialog__body {
      background: #F8F8F8;
    }
    .el-dialog__header {
      text-align: center;
    }
    .el-dialog__footer {
      text-align: center;
      .dialog-footer {
        text-align: center;
        button {
          height: 45px;
          width: 160px;
        }
      }
    }
  }
  .poAddressBox {
    .noAddress {
      width: 300px;
      height: 166px;
      display: flex;
      align-items: center;
      text-align: center;
      border: 2px solid #DDDDDD;
      border-radius: 4px;
      margin-top: 40px;
      justify-content: center;
      cursor: pointer;
      margin-bottom: 70px;
      span {
        font-size: 16px;
        color: #666666;
        display: block;
      }
      span:nth-child(1) {
        font-size: 26px;
        margin-bottom: 18px;
      }
    }
  }
  .orderList {
    background: #FCFCFC;
    border: 1px solid #E5E5E5;
    margin-bottom: 5px;
    .orderInfoTit {
      width: 100%;
      display: flex;
      height: 32px;
      line-height: 32px;
      color: #333333;
      font-size: 14px;
      font-weight: 400;
    }
    span {
      text-align: center;
    }
    span:nth-child(1) {
      width: 40%;
      text-align: left;
      padding-left: 125px;
      box-sizing: border-box;
    }
    span:nth-child(2) {
      width: 20%;
      text-align: left;
    }
    span:nth-child(3) {
      width: 15%;
    }
    span:nth-child(4) {
      width: 15%;
    }
    span:nth-child(5) {
      width: 10%;
    }
    span:nth-child(6) {
      width: 10%;
    }
  }
  .couponBox {
    .couponTitle {
      color: #333333;
      font-size: 16px;
      font-weight: bold;
      height: 45px;
      line-height: 45px;
      border-bottom: 1px solid #E5E5E5;
      span {
        color: #333333;
        cursor: pointer;
        i {
          margin-left: 5px;
        }
      }
    }
    .discountList {
      margin-top: 30px;
      .couponItem {
        width: 245px;
        border: 1px solid #EEEEEE;
        border-radius: 18px;
        overflow: hidden;
        margin:0 100px 50px 0;
        float: left;
        cursor: pointer;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .couponItemTop {
          background: #fd5b5b;
          color: #ffffff;
          padding: 20px;
          box-sizing: border-box;
          position: relative;
          img {
            opacity: 0.2;
            position: absolute;
            top: 40%;
          }
          .couponType {
            position: absolute;
            top: 1px;
            right: -33px;
            width: 100px;
            transform: rotate(45deg);
            background: #FFFFFF;
            color: #fd5b5b;
            text-align: center;
            height: 40px;
            line-height: 50px;
          }
          span {
            font-size: 12px;
            display: block;
            margin-bottom: 18px;
            i {
              margin-right: 5px;
              font-style: normal;
              font-size: 16px;
            }
          }
          span:nth-child(2) {
            font-size: 28px;
          }
          span:nth-child(4) {
            margin-bottom: 0;
          }
        }
        .couponItemBot {
          height: 40px;
          line-height: 40px;
          background: #f3f3f3;
          color: #333333;
          position: relative;
          text-align: center;
          cursor: pointer;
          .currentSelect {
            color: $mainColor;
            position: absolute;
            right: -1px;
            bottom: 0;
            font-size: 40px;
          }
        }
      }
      .active {
        border: 1px solid $mainColor;
      }
    }
    .couponList {
      margin-top: 10px;
    }
  }
  .payBox {
    .payTit {
      font-size: 16px;
      color: #333333;
    }
  }
  .placeOrderBtn {
    margin-top: 50px;
    width: 100%;
    background: #F7F7F7;
    padding: 30px;
    box-sizing: border-box;
    text-align: right;
    span {
      display: block;
      margin-bottom: 20px;
      font-size: 14px;
      color: #333333;
    }
    //span:nth-child(1) {
    //  font-size: 18px;
    //  b {
    //    color: $mainColor;
    //  }
    //}
    //span:nth-child(2) {
    //  font-size: 18px;
    //  b {
    //    color: $mainColor;
    //  }
    //}
    span:nth-child(4) {
      font-size: 18px;
      b {
        color: $mainColor;
      }
    }
  }
  .payList {
    display: flex;
    margin: 20px 0 0 50px;
    span {
      color: #666666;
      font-size: 16px;
      font-weight: 400;
      display: flex;
      align-items: center;
      cursor: pointer;
      position: relative;
      i {
        font-size: 26px;
        margin-right: 5px;
      }
      b {
        color: $mainColor;
        position: absolute;
        right: -1px;
        bottom: -1px;
        display: none;
      }
    }
    .payActive {
      border: 1px solid $mainColor;
      b {
        display: block;
      }
    }
    span {
      border: 1px solid #E5E5E5;
      padding: 5px 10px;
      margin-right: 15px;
    }
    span:nth-child(1) {
      i:nth-child(1) {
        color: #40ba49;
        cursor: pointer;
      }
    }
    span:nth-child(2) {
      i {
        color:  #40ba49;
      }
    }
  }
  .payment {
    width: 80%;
    margin: 0 auto;
    .paymentBox {
      margin-top: 50px;
      display: flex;
      justify-content: center;
      .successBox, .errorBox {
        width: 240px;
        text-align: center;
      }
      .successBox {
        border-right: 1px solid #DDDDDD;
        >>> .el-button {
          border: 1px solid $mainColor;
        }
      }
      span {
        display: block;
        margin-bottom: 20px;
      }
    }
    .paymentInfo {
      text-align: center;
      margin-top: 60px;
      p {
        font-size: 16px;
        color: #999999;
        line-height: 30px;
        b {
          color: #D22929;
          cursor: pointer;
          font-weight: normal;
        }
      }
    }
  }
  .weChatBox {
    display: flex;
    img {
      width: 100%;
    }
    .qCode {
      width: 50%;
      text-align: center;

    }
    .weChatInfo {
      width: 50%;
    }
  }
  .weChat {
    >>> .el-dialog__body {
      background: #FFFFFF;
    }
  }
  .errorDialog {
    text-align: center;
    .errorTit {
      span {
        font-size: 50px;
        color: red;
      }
      p {
        margin: 30px 0;
      }
    }
    span {
      display: block;
    }
  }
  .remarksBox {
    display: flex;
    background: #F7F7F7;
    padding: 25px;
    border-radius: 8px;
    margin-bottom: 30px;
    .remarksInfo {
      width: 100%;
      >>> .el-textarea__inner {
        width: 100%;
        height: 84px;
      }
    }
    .selectBox {
      margin-left: 70px;
      label {
        color: #666666;
        font-size: 16px;
        font-weight: normal;
      }
    }
    .shopTotal {
      color: $mainColor;
      flex: 1;
      text-align: right;
    }
  }
}
.el-input{
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/placeOrder/index.vue